import { render, staticRenderFns } from "./TransactionRechargeHistory.vue?vue&type=template&id=06e6e470&"
import script from "@/scripts/payment/transactionRechargeHistory.js?vue&type=script&lang=js&"
export * from "@/scripts/payment/transactionRechargeHistory.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports